<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs v3-portlet">
  <!-- <app-loader [showLoader]=showLoad></app-loader> -->
  <div class="cards-holder devices-tab">
    <div class="card card2 mRight">
      <app-datatable-v3 [sectiontitle]="sectiontitle" [datatableconfig]="devicedatatableconfig" [key]="key"></app-datatable-v3>
    </div>
    <div class="card card1 mLeft devices-placement-carousel">
      <div class="c-portlet__header">
        <div class="o-stack__cell">
          <h5>Screenshots</h5>
        </div>
      </div>
      <div class="screenshot-carousel">
        <div class="selected-image-container">
          <div class="selected-image" [ngStyle]="{'background-image': 'url('+previewData.imageURL+')'}">
            <div class="leftArrow" (click)="changePreviewScreenshot(activeIndex -1)" *ngIf="screenShotsData.length > 1">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </div>
            <div class="rightArrow" (click)="changePreviewScreenshot(activeIndex + 1)" *ngIf="screenShotsData.length > 1">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </div>
          </div>
          <div class="title-container" (click)="previewScreenShotInNewTab(previewData.imageURL)">
            <span class="title">{{previewData.url}}</span>
            <span class="sub-title">{{previewData.date}}</span>
          </div>
        </div>
        <div class="carousel-container" *ngIf="hasData">
          <ngu-carousel [inputs]="carouselOne" #carousel [dataSource]="screenShotsData">
            <ngu-tile  *nguCarouselDef="let screenshot;let index =index">
              <div class="c-portlet__content">
                <div class="screenshotscontent" (click)="previewScreenshot(screenshot, index)" [ngClass]="{'active-img':index == activeIndex}">
                  <div class="image" [ngStyle]="{'background-image': 'url('+screenshot?.imageURL+')'}"></div>
                  <div class="info-container">
                    <div class="title">{{screenshot?.url}}</div>
                    <div class="sub-title">{{screenshot?.date}}</div>
                  </div>
                </div>
              </div>
            </ngu-tile>
            <span NguCarouselPrev class="leftRs">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
            </span>
            <span NguCarouselNext class="rightRs">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </ngu-carousel>
        </div>
        <div class="no-data-container" *ngIf="!hasData">
          <div class="map-no-data">No Data to Display</div>
        </div>
      </div>
    </div>
  </div>
</div>
